import { atom, useStore } from 'jotai'
import { atomWithReset, RESET } from 'jotai/utils'
import {
  ChatMessageStatusEnum,
  getConversationList_openAiQuery_pageConversation_edges_node,
  ChatRole,
} from '~/graphqls/types'

export const messageListRefAtom = atomWithReset<HTMLDivElement | null>(null)

export const deepseekMethodAtom = atomWithReset<Array<'thinking' | 'search'>>([
  'thinking',
])

export interface IConversation {
  messages?: IMessage[]
}
export interface IMessage {
  id: any
  role: ChatRole
  /** 消息文本内容 */
  content: string
  /** 消息图片内容 */
  image?: string
  thinkingTime?: number
  reasoning?: string
  done?: boolean
  conversationId?: number
  parentId?: number
  searchEnabled?: boolean
  thinkingEnabled?: boolean
  error?: boolean
  errorReason?: string
  searchResults?: ISearchResult[]
  status?: ChatMessageStatusEnum
  referImages?: string[]
  [key: string]: any
}

export interface ISearchResult {
  content_type?: string
  favicon?: string
  id?: number
  site?: string
  snippet?: string
  title?: string
  url?: string
  date?: number
}

export const conversationIdAtom = atomWithReset<number | null>(null)
export const curHistoryConversationAtom = atomWithReset<
  getConversationList_openAiQuery_pageConversation_edges_node | undefined
>(undefined)

/** 所有会话的数据 */
export const chatMessagesAtom = atomWithReset<Record<any, IConversation>>({})
/** 当前回话的数据 */
export const selectMessageAtom = atom(get => {
  const conversationId = get(conversationIdAtom)
  const chatMessages = get(chatMessagesAtom)
  if (!conversationId) return []
  return chatMessages?.[conversationId]?.messages || []
})

/** 机器人响应占位 */
export const placeholderAtom = atomWithReset<IMessage | null>(null)
/** 是否更新历史记录 */
export const isUpdateHistoryAtom = atomWithReset<boolean>(false)

/** 当前搜索结果 */
export const searchResultsAtom = atomWithReset<ISearchResult[] | null>(null)

/** 需要轮询的会话id */
export const pollConversationIdsAtom = atomWithReset<string[]>([])

/** 重置atom值 */
export const resetAllAtoms = (store: ReturnType<typeof useStore>) => {
  const set = store.set

  set(chatMessagesAtom, RESET)
  set(conversationIdAtom, RESET)
  set(pollConversationIdsAtom, RESET)
  set(searchResultsAtom, RESET)
  set(placeholderAtom, RESET)
  set(curHistoryConversationAtom, RESET)
  set(deepseekMethodAtom, RESET)
  set(messageListRefAtom, RESET)
  set(isUpdateHistoryAtom, RESET)
}
